/**
 * Client-side mirror of the backend recurrence helpers — used for labels and
 * preset → rule conversion in the UI. Weekday convention: Monday = 0, Sun = 6.
 */
export const WEEKDAY_NAMES = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const WEEKDAY_FULL = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const RECURRENCE_COLORS = {
  daily: "#0EA5E9",        // sky blue
  weekdays: "#3B82F6",     // bright blue
  weekly: "#842DDA",       // purple
  monthly: "#06B6D4",      // cyan
  quarterly: "#F97522",    // orange
  yearly: "#EC4899",       // pink
  custom: "#F59E0B",       // amber
};

export function normaliseRecurrence(rec, legacy) {
  if (rec && rec.freq) return { interval: 1, ...rec };
  if (!legacy || legacy === "none") return null;
  switch (legacy) {
    case "daily":     return { freq: "daily", interval: 1 };
    case "weekdays":  return { freq: "weekdays", interval: 1 };
    case "weekly":    return { freq: "weekly", interval: 1 };
    case "monthly":   return { freq: "monthly", interval: 1, monthly_mode: "day_of_month" };
    case "quarterly": return { freq: "quarterly", interval: 1 };
    case "yearly":    return { freq: "yearly", interval: 1 };
    default:          return null;
  }
}

export function recurrenceLabel(rec) {
  if (!rec || !rec.freq) return "";
  const i = rec.interval || 1;
  switch (rec.freq) {
    case "daily":
      return i === 1 ? "Daily" : `Every ${i} days`;
    case "weekdays":
      return "Weekdays";
    case "weekly": {
      const days = (rec.by_weekdays || []).slice().sort();
      if (i === 1 && days.length > 0 && days.length <= 3) {
        return "Every " + days.map((d) => WEEKDAY_NAMES[d]).join(", ");
      }
      return i === 1 ? "Weekly" : `Every ${i} weeks`;
    }
    case "monthly":
      return i === 1 ? "Monthly" : `Every ${i} months`;
    case "quarterly":
      return "Quarterly";
    case "yearly":
      return i === 1 ? "Yearly" : `Every ${i} years`;
    default:
      return "";
  }
}

export function recurrenceColor(rec) {
  if (!rec || !rec.freq) return null;
  const f = rec.freq;
  if (f === "weekly" && (rec.interval || 1) !== 1) return RECURRENCE_COLORS.custom;
  if (f === "daily" && (rec.interval || 1) !== 1) return RECURRENCE_COLORS.custom;
  if (f === "monthly" && (rec.interval || 1) !== 1) return RECURRENCE_COLORS.custom;
  return RECURRENCE_COLORS[f] || RECURRENCE_COLORS.custom;
}

export function legacyFromStructured(rec) {
  if (!rec || !rec.freq) return "none";
  if ((rec.interval || 1) !== 1) return "custom";
  return rec.freq;
}
